export enum SliderStrengthEnum {
  None = 'none',
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  VeryHigh = 'very-high',
}

export const sliderStrengthMap = [
  { min: 0, value: SliderStrengthEnum.Low },
  { min: 25, value: SliderStrengthEnum.Medium },
  { min: 50, value: SliderStrengthEnum.High },
  { min: 75, value: SliderStrengthEnum.VeryHigh },
]
